export default __webpack_public_path__ + "static/media/add_more_here_arrow_pink.623b541f.svg";